<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('disciplinaryLetter.pageTitle') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-7">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'disciplinary-letter-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-5 d-flex justify-content-end">
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width:600px"
              @change="fetchData"
              class="mr-2"
            />
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.student ? record.student.card_number : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.student ? record.student.full_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.student ? record.student.gender : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.disciplinary_type
                  ? record.disciplinary_type.dis_type_en +
                    '|' +
                    record.disciplinary_type.dis_type_kh
                  : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.disciplinary_sub_type
                  ? record.disciplinary_sub_type.dis_sub_type_en +
                    '|' +
                    record.disciplinary_sub_type.dis_sub_type_kh
                  : ''
              }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.issued_date }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <a
                href="#"
                v-if="record.disciplinary_activity.letter_type"
                v-tooltip="$t('pdf')"
                class="mr-2 text-danger"
                @click.prevent="pdfView(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('tooltip.delete')"
                class="text-danger"
                @click.prevent="showForm(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './delete-form.vue'
import PreviewPDF from './component/preview-pdf'

export default {
  name: 'disciplinary-letter',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('disciplinaryLetter', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.disciplinaryLetter.search
      },
      set (newValue) {
        this.$store.commit('disciplinaryLetter/SET_SEARCH', newValue)
        this.$store.commit('disciplinaryLetter/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        { name: this.$t('disciplinaryLetter.cardNumber') },
        {
          name: this.$t('disciplinaryLetter.studentName')
        },
        {
          name: this.$t('disciplinaryLetter.sex'),
          style: 'text-align:center'
        },
        {
          name: this.$t('disciplinaryLetter.disciplinaryType')
        },
        {
          name: this.$t('disciplinaryLetter.disciplinarySubType')
        },
        {
          name: this.$t('disciplinaryLetter.issueDate'),
          style: 'text-align:center'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:1%'
        }
      ]
    },
    dateRange: {
      get () {
        return this.$store.state.disciplinaryLetter.dateRange
      },
      set (newValue) {
        this.$store.commit('disciplinaryLetter/SET_DATE_RANGE', newValue)
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('disciplinaryLetter/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    showForm (data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    pdfView(record) {
      this.$modal.show(
        PreviewPDF,
        {
          url: null,
          letter_type: record.disciplinary_activity.letter_type,
          dis_letter_id: record.dis_letter_id
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('disciplinaryLetter/RESET_STATE')
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
